var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGenericFile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 28,
    viewBox: "0 0 20 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.28538 0.686523H13.5711L19.9997 7.1151V23.5437C19.9997 23.9225 19.8492 24.2859 19.5812 24.5538C19.3133 24.8217 18.95 24.9722 18.5711 24.9722H4.28538C3.9065 24.9722 3.54314 24.8217 3.27523 24.5538C3.00732 24.2859 2.85681 23.9225 2.85681 23.5437V2.11509C2.85681 1.73621 3.00732 1.37285 3.27523 1.10494C3.54314 0.837033 3.9065 0.686523 4.28538 0.686523ZM17.8568 7.1151L13.5711 2.82938V6.40081C13.5711 6.59025 13.6464 6.77193 13.7803 6.90589C13.9143 7.03984 14.0959 7.1151 14.2854 7.1151H17.8568ZM16.219 12.3244C16.3529 12.4583 16.4281 12.64 16.4281 12.8294C16.4281 13.0188 16.3529 13.2004 16.219 13.3344L9.99967 19.5537L6.63753 16.1915C6.50741 16.0568 6.43542 15.8764 6.43704 15.6891C6.43867 15.5018 6.51379 15.3227 6.64623 15.1902C6.77866 15.0578 6.95781 14.9827 7.1451 14.981C7.33238 14.9794 7.51281 15.0514 7.64753 15.1815L9.99967 17.5337L15.209 12.3244C15.3429 12.1905 15.5246 12.1152 15.714 12.1152C15.9034 12.1152 16.085 12.1905 16.219 12.3244Z",
    fill: "#8A68C8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.42894 4.97217H0.000366211V24.2579C0.000366211 25.2051 0.376641 26.1135 1.04641 26.7833C1.71619 27.453 2.62459 27.8293 3.57179 27.8293H17.1432V26.4007H3.57179C3.00347 26.4007 2.45843 26.175 2.05657 25.7731C1.6547 25.3712 1.42894 24.8262 1.42894 24.2579V4.97217Z",
    fill: "#8A68C8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGenericFile);
export default __webpack_public_path__ + "static/media/generic-file.813c786a13484553014addc643bf68f0.svg";
export { ForwardRef as ReactComponent };